import type { PaymentMethodItem } from '../PaymentMethods.types'

export const getDefaultPaymentMethod = (paymentMethods?: PaymentMethodItem[]) =>
  paymentMethods?.find((paymentMethodProps) => paymentMethodProps.default)
